var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.25,
    height: 92.498,
    viewBox: "0 0 91.25 92.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-3, .cls-4 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n        stroke-width: 2.5px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        fill: #00b0a9;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498",
    transform: "translate(-627 -296.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489",
    transform: "translate(520 298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9661",
    "data-name": "Group 9661",
    transform: "translate(137.046 27.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9659",
    "data-name": "Group 9659",
    transform: "translate(7.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    className: "cls-1",
    d: "M142.37,40.648c-4.743,0-8.37-4.491-8.37-10.526,0-4.21.977-9.122,8.37-9.122s8.37,4.912,8.37,9.122C150.74,36.157,147.113,40.648,142.37,40.648Z",
    transform: "translate(-134 -21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9660",
    "data-name": "Group 9660",
    transform: "translate(0 17.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    className: "cls-1",
    d: "M139.864,34.491l-11.051,5.193v7.1c0,1.684.977,2.807,1.4,2.807h28.272c.419,0,1.395-1.123,1.395-2.807V39.824l-11.051-5.193",
    transform: "translate(-128.812 -34.491)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9662",
    "data-name": "Group 9662",
    transform: "translate(146.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    className: "cls-1",
    d: "M145.765,11.228H137.4a1.322,1.322,0,0,1-1.4-1.4V1.4A1.322,1.322,0,0,1,137.4,0h8.37a1.322,1.322,0,0,1,1.4,1.4V9.824A1.322,1.322,0,0,1,145.765,11.228Z",
    transform: "translate(-136)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9663",
    "data-name": "Group 9663",
    transform: "translate(145.974 78.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    className: "cls-1",
    d: "M147.575,67.207h-11.16a1.463,1.463,0,0,1-1.255-.7,1.281,1.281,0,0,1,0-1.4l5.58-8.421a1.429,1.429,0,0,1,2.371,0l5.58,8.421a1.281,1.281,0,0,1,0,1.4A1.1,1.1,0,0,1,147.575,67.207Z",
    transform: "translate(-134.95 -56.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9664",
    "data-name": "Group 9664",
    transform: "translate(107 38.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-2",
    d: "M115.029,42.058a7.029,7.029,0,1,1,7.029-7.029A7.05,7.05,0,0,1,115.029,42.058Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10473",
    "data-name": "Group 10473",
    transform: "translate(188.563 40.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10475",
    "data-name": "Group 10475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9666",
    "data-name": "Group 9666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    className: "cls-3",
    d: "M174.828,30.391l-8.437,8.438",
    transform: "translate(-166.391 -30.391)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10474",
    "data-name": "Group 10474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7005-2",
    "data-name": "Path 7005",
    className: "cls-3",
    d: "M166.391,30.391l8.438,8.438",
    transform: "translate(-166.391 -30.391)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9667",
    "data-name": "Group 9667",
    transform: "translate(113.858 5.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    className: "cls-3",
    d: "M112,33.092A40.6,40.6,0,0,1,141.016,3.9",
    transform: "translate(-112 -3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9670",
    "data-name": "Group 9670",
    transform: "translate(163.102 5.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    className: "cls-3",
    d: "M147.5,4A40.237,40.237,0,0,1,176.38,33.051",
    transform: "translate(-147.503 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(175.238 64.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10471",
    "data-name": "Group 10471",
    transform: "translate(113.858 55.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006-2",
    "data-name": "Path 7006",
    className: "cls-3",
    d: "M112,3.9a40.6,40.6,0,0,0,29.016,29.192",
    transform: "translate(-112 -3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10472",
    "data-name": "Group 10472",
    transform: "translate(163.102 55.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7009-2",
    "data-name": "Path 7009",
    className: "cls-3",
    d: "M147.5,33.051A40.237,40.237,0,0,0,176.38,4",
    transform: "translate(-147.503 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10476",
    "data-name": "Group 10476",
    transform: "translate(174.246 43.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-2",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10477",
    "data-name": "Group 10477",
    transform: "translate(179.206 43.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-3",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10478",
    "data-name": "Group 10478",
    transform: "translate(126.63 43.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-4",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10479",
    "data-name": "Group 10479",
    transform: "translate(131.59 43.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-5",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10480",
    "data-name": "Group 10480",
    transform: "translate(131.59 64.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-6",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10481",
    "data-name": "Group 10481",
    transform: "translate(131.59 22.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-7",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10482",
    "data-name": "Group 10482",
    transform: "translate(174.246 22.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-8",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10484",
    "data-name": "Group 10484",
    transform: "translate(152.918 69.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-9",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10485",
    "data-name": "Group 10485",
    transform: "translate(152.918 17.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-10",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V2.807",
    transform: "translate(-2.812)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiHover);
export default __webpack_public_path__ + "static/media/si-hover.42c41f5c02e7a2a4b2ecd6c5e3ef09e0.svg";
export { ForwardRef as ReactComponent };